import { Text } from '@aws-amplify/ui-react';
import * as React from 'react';

const ConfirmResetPassword = {
  Header: () => <Text>Code has been sent to your email</Text>,
};

export default ConfirmResetPassword;
